var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:['email_spacer', _vm.advanced.cssClasses, _vm.responsiveClasses],style:(_vm.style),attrs:{"id":_vm.advanced.cssId}})
}
var staticRenderFns = []

export { render, staticRenderFns }